import React, { Component } from "react";
import { Modal, Icon, Radio, Row, Collapse, Alert, Button } from "antd";
import storage from "redux-persist/lib/storage";
import { Trans, withTranslation } from "react-i18next";
import Colors from "../themes/Colors";

const { Panel } = Collapse;

class LanguageCurrencyModal extends Component {
  constructor(props) {
    super(props);
    this.props.getCountries();
    this.props.getlocation();
    this.state = {
      language: this.props.i18n.language,
      currencies: [],
      selectedCountry: this.props.billingCountry,
      selectedCodeCountry: this.props.invoiceIssuingCountry,
      selectedCurrency: [],
      currencyOptionSelected: null,
      automaticCurrencyChange: false
    };
    document.documentElement.lang = 'es';
    this.defaultCurrency();
  }

  componentDidUpdate(nextProps) {
    if(nextProps.editCampaignActive !== this.props.editCampaignActive){
      this.defaultCurrency();
    } else if (
      nextProps.location !== this.props.location ||
      nextProps.countries !== this.props.countries ||
      nextProps.dsp !== this.props.dsp
    ){
      this.defaultCurrency();
    }

    if (nextProps.dsp !== this.props.dsp) {
      this.setAutomaticCurrencyChange(true);
    }
  }

  setAutomaticCurrencyChange(value) {
    this.setState({
      automaticCurrencyChange: value
    });
  }

  // Check if user has authorized countries and if location matches any of them
  checkAuthorizedCountries = ({location, countries}) => {
    if (location && location.country_code) {
      const isAuthorized = countries.some(country => country.alpha_2_code === location.country_code);
      return isAuthorized;
    }
    return false;
  };

  defaultCurrency() {
    const { countries,
            location,
            user,
            setBilling,
            setCampaignBillingInfo,
            billingCountry,
            currentCampaign,
            editCampaignActive,
            dsp,
            programmatic,
            isSuperUser
            } = this.props;

    let matchCountry, currencySelected;

    // first case: edit campaign
    if(editCampaignActive) {

      if ((dsp && dsp.id) && !(programmatic == "traditional" && !isSuperUser)) {
        // Configure international currency and disable other options when the DPS is not Latin.
        matchCountry = countries.filter((country) => country.alpha_2_code === "F")
        setCampaignBillingInfo("USD", "Factura Internacional", "F");
        this.settingCurrency(matchCountry[0].currencies, matchCountry[0].default_currency, "USD")
        this.setState({
          selectedCountry: "Factura Internacional", 
          selectedCodeCountry: "F",
          selectedCurrency: "USD"
        });
        // this.convertAndSetBudget("USD");
      }else {
        matchCountry = countries.filter((country) => country.name === currentCampaign.invoice_issuing.name)
  
        setCampaignBillingInfo(
          currentCampaign.currency, 
          currentCampaign.invoice_issuing.name,
          currentCampaign.invoice_issuing.alpha_2_code
        );
        this.settingCurrency(matchCountry[0].currencies, matchCountry[0].default_currency, currentCampaign.currency)
        this.setState({
          selectedCountry: currentCampaign.invoice_issuing.name,
          selectedCodeCountry: currentCampaign.invoice_issuing.alpha_2_code,
          selectedCurrency: currentCampaign.currency
        });
        // this.convertAndSetBudget(currentCampaign.currency);
      }
      return;
    };

    const isLocationAuthorized = this.checkAuthorizedCountries({location, countries});

    // Check if the company country is in the allowed countries array
    const isCompanyCountryAuthorized = user && user.company && 
      countries.some(country => country.name === user.company.country);

    // If the user has company but its country is not authorized, use International billing
    if (user && user.company && !isCompanyCountryAuthorized) {
      setBilling("USD", "Factura Internacional", "F");
      this.setState({ 
        selectedCountry: "Factura Internacional", 
        selectedCodeCountry: "F",
        selectedCurrency: "USD"
      });
      return;
    }

    // If the location is authorized but the company country is not
    if (isLocationAuthorized && !isCompanyCountryAuthorized) {
      if (location && location.country_code) {
        matchCountry = countries.filter((country) => country.alpha_2_code === location.country_code);
        if (matchCountry && matchCountry.length > 0) {
          setBilling(
            matchCountry[0].default_currency.code,
            matchCountry[0].name,
            matchCountry[0].alpha_2_code
          );
          this.setState({
            selectedCountry: matchCountry[0].name,
            selectedCodeCountry: matchCountry[0].alpha_2_code,
            selectedCurrency: matchCountry[0].default_currency.code
          });
          return;
        }
      }
    }

    // New logic for handling cases when isLocationAuthorized is false
    if (!isLocationAuthorized) {
      if (!user || !user.company) {
        // Case 1: isLocationAuthorized is false and user.company is null
        setBilling("USD", "Factura Internacional", "F");
        this.setState({ 
          selectedCountry: "Factura Internacional", 
          selectedCodeCountry: "F",
          selectedCurrency: "USD"
        });
        return;
      } else {
        // Case 2: isLocationAuthorized is false but user.company has data
        matchCountry = countries.filter((country) => country.name === user.company.country);
        
        if (matchCountry && matchCountry.length > 0) {
          setBilling(
            user.company.currency,
            user.company.country,
            matchCountry[0].alpha_2_code
          );
          this.setState({
            selectedCountry: user.company.country,
            selectedCodeCountry: matchCountry[0].alpha_2_code,
            selectedCurrency: user.company.currency
          });
          return;
        } else if (location && location.country_code) {
          // If the company country don't exist, try to use the location
          matchCountry = countries.filter((country) => country.alpha_2_code === location.country_code);
          if (matchCountry && matchCountry.length > 0) {
            setBilling(
              matchCountry[0].default_currency.code,
              matchCountry[0].name,
              matchCountry[0].alpha_2_code
            );
            this.setState({
              selectedCountry: matchCountry[0].name,
              selectedCodeCountry: matchCountry[0].alpha_2_code,
              selectedCurrency: matchCountry[0].default_currency.code
            });
            return;
          }
        }
        // If none of the above works, use international billing
        setBilling("USD", "Factura Internacional", "F");
        this.setState({ 
          selectedCountry: "Factura Internacional", 
          selectedCodeCountry: "F",
          selectedCurrency: "USD"
        });
        return;
      }
    } else {
      // Case 3: isLocationAuthorized is true
      if (!user || !user.company) {
        // If no user, use location country
        matchCountry = countries.filter((country) => country.alpha_2_code === location.country_code);
        if (matchCountry && matchCountry.length > 0) {
          setBilling(
            matchCountry[0].default_currency.code,
            matchCountry[0].name,
            matchCountry[0].alpha_2_code
          );
          this.setState({
            selectedCountry: matchCountry[0].name,
            selectedCodeCountry: matchCountry[0].alpha_2_code,
            selectedCurrency: matchCountry[0].default_currency.code
          });
          return;
        }
      }
    }

    // Existing logic for other cases
    if ((dsp && dsp.id) && !(programmatic == "traditional" && !isSuperUser)) {
      // Configure international currency and disable other options when the DPS is not Latin.
      matchCountry = countries.filter((country) => country.alpha_2_code === "F")
    } else {
        if(billingCountry){
          matchCountry = countries.filter((country) => country.name === billingCountry);
          currencySelected = this.props.currency;
        }else if(user && user.company){
          //setting currency by default and not currency of de company because this can change
          matchCountry = countries.filter((country) => country.name === user.company.country);
        }else if(location){
          matchCountry = countries.filter((country) => country.alpha_2_code === location.country_code)
        }else{
          matchCountry = countries.filter((country) => country.alpha_2_code === "AR")
        }
    }
    if(matchCountry && matchCountry.length > 0){
      setBilling(currencySelected ? currencySelected : matchCountry[0].default_currency.code,
                 matchCountry[0].name,
                 matchCountry[0].alpha_2_code);
      this.settingCurrency(matchCountry[0].currencies, matchCountry[0].default_currency, currencySelected)
      this.setState({ selectedCountry: matchCountry[0].name, selectedCodeCountry: matchCountry[0].alpha_2_code});
    }
  }

  settingCurrency = (currencies, defaultCurrency, selectedCurrency=null) => {
    var listCurrencies = [...currencies];
    listCurrencies.push({code: defaultCurrency.code,
                         description: defaultCurrency.description
                        });
    this.setState({
      selectedCurrency: selectedCurrency ? selectedCurrency : defaultCurrency.code,
      currencies: listCurrencies,
    });
  }

  handleCountrySelection = ({ target }) => {
    let matchCountry = this.props.countries.filter((country) => country.name === target.value.name)
    this.settingCurrency(matchCountry[0].currencies, matchCountry[0].default_currency);
    this.setState({
      selectedCountry: target.value.name,
      selectedCodeCountry: matchCountry[0].alpha_2_code,
    });
    this.setAutomaticCurrencyChange(false);
  };

  handleCurrencySelection = ({ target }) => {
    this.setState({
      selectedCurrency: target.value,
    });
    this.setAutomaticCurrencyChange(false);
  };

  // convertAndSetBudget = (selectedCurrency) => {
  //   const { conversionRates, campaignCurrency, amountBudget, setBudget } = this.props;

  //   // Find the exchange rates for both currencies (both relative to USD)
  //   const currentCurrencyRate = conversionRates.find((rate) => rate.currency === campaignCurrency);
  //   const selectedCurrencyRate = conversionRates.find((rate) => rate.currency === selectedCurrency);

  //   if (currentCurrencyRate && selectedCurrencyRate) {
  //     const convertedAmount = amountBudget * (selectedCurrencyRate.rate / currentCurrencyRate.rate);
      
  //     const roundedAmount = Math.round(convertedAmount * 100) / 100;
      
  //     setBudget(roundedAmount);
  //   }
  // }

  handleOk = () => {
    const { selectedCountry, selectedCodeCountry, selectedCurrency, language } = this.state;
    
    if(this.props.editCampaignActive && this.state.currencyOptionSelected === "convert"){
      this.props.convertAndSetBudget(selectedCurrency);
    }
    
    if(this.props.editCampaignActive){
      this.props.setCampaignBillingInfo(selectedCurrency, selectedCountry, selectedCodeCountry)
    } else {
      this.props.setBilling(selectedCurrency, selectedCountry, selectedCodeCountry)
    }
    this.props.i18n.changeLanguage(language);
    storage.setItem("language", language);
    document.documentElement.lang = language;
    this.setState({ currencyOptionSelected: null });


    this.props.onOk();
  };

  changeLanguage = ({ target }) => {
    this.setState({
      ...this.state, language: target.value,
    });
    this.setAutomaticCurrencyChange(false);
  };

  // Initializa state
  closeModal = () => {
    // If the campaign is being edited, use the campaign billing country, otherwise use the user billing country
    const usedBillingCountry = this.props.editCampaignActive ? this.props.campaignBillingCountry : this.props.billingCountry

    let matchCountry = this.props.countries.filter((country) => country.name === usedBillingCountry)
    this.settingCurrency(matchCountry[0].currencies, matchCountry[0].default_currency);
    this.setState({
      selectedCountry: matchCountry[0].name,
      selectedCodeCountry: matchCountry[0].alpha_2_code,
      language: this.props.i18n.language,
    });
  };

  setCurrencyOption = (currencyOption) => {
    this.setState({ 
      currencyOptionSelected: currencyOption,
    });
    this.setAutomaticCurrencyChange(false);
  }

  render() {

    const { visible, onCancel, cancelText, t, countries , dsp, programmatic, isSuperUser, campaignCurrency, campaignBillingCountry, campaignInvoiceIssuingCountry, editCampaignActive, currency, billingCountry, invoiceIssuingCountry} = this.props;
    const {
      language,
      selectedCountry,
      selectedCurrency,
      currencies,
      automaticCurrencyChange
    } = this.state;

    let diseabledOptions = (!!dsp && dsp.id) && ( programmatic == "programmatic" || (programmatic == "traditional" && !isSuperUser) )

    // If the campaign is being edited, use the campaign currency, otherwise use the user currency
    const usedCurrency = editCampaignActive ? campaignCurrency : currency
    // If the campaign is being edited, use the campaign billing country, otherwise use the user billing country
    const usedBillingCountry = editCampaignActive ? campaignBillingCountry : billingCountry
    // If the campaign is being edited, use the campaign invoice issuing country, otherwise use the user invoice issuing country
    // const usedInvoiceIssuingCountry = editCampaignActive ? campaignInvoiceIssuingCountry : invoiceIssuingCountry

    const customPanelStyle = {
      background: Colors.snow,
      borderRadius: 4,
      marginBottom: 10,
      border: 0,
      overflow: "hidden",
    };
    // var selectedCurrencys = "ARS"
    return (
      <Modal
        bodyStyle={{ padding: 20 }}
        title={t("Language & Currency configuration")}
        visible={visible}
        width={600}
        okText={automaticCurrencyChange ? t("Accept") : t("Apply settings")}
        okButtonProps={{
          disabled:
            !automaticCurrencyChange &&
            (usedCurrency === selectedCurrency &&
            usedBillingCountry === selectedCountry &&
            this.props.i18n.language === language) ||
            (editCampaignActive && usedCurrency !== selectedCurrency && this.state.currencyOptionSelected === null)
        }}
        onOk={automaticCurrencyChange ? onCancel : this.handleOk}
        cancelText={cancelText}
        onCancel={onCancel}
        afterClose={this.closeModal}
      >
        <Row>
          <div>
            <Collapse
              bordered={false}
              defaultActiveKey={["1"]}
              expandIcon={({ isActive }) => (
                <Icon type="caret-right" rotate={isActive ? 90 : 0} />
              )}
              style={{ backgroundColor: Colors.snow }}
            >
              <Panel
                header={t("Language")}
                key="1"
                style={(customPanelStyle, { marginBottom: "10px" })}
                showArrow={false}
              >
                <Radio.Group
                  defaultValue={`${language}`}
                  buttonStyle="solid"
                  onChange={this.changeLanguage}
                >
                  <Radio.Button checked={language === 'en'} value="en">
                    English
                  </Radio.Button>
                  <Radio.Button checked={language === 'es'} value="es">
                    Español (Latino)
                  </Radio.Button>
                  <Radio.Button checked={language === 'es_ar'} value="es_ar">
                    Español (Argentina)
                  </Radio.Button>
                </Radio.Group>
              </Panel>
            </Collapse>
            <Collapse
              bordered={false}
              defaultActiveKey={["1"]}
              expandIcon={({ isActive }) => (
                <Icon type="caret-right" rotate={isActive ? 90 : 0} />
              )}
              style={{ backgroundColor: Colors.snow }}
            >
              <Panel
              header={(
                <div>
                  {t('Billing Country')}
                  <br />
                  {/* <span className="info-fi">Solo se puede configurar FI cuando el DSP no es Latinad</span> */}
                </div>
              )}
                key="1"
                style={customPanelStyle}
                showArrow={false}
              >
                <Radio.Group
                  buttonStyle="solid"
                  onChange={this.handleCountrySelection}
                  style={{ paddingRight:"10px" , paddingLeft: "10px" }}
                >
                  {countries.map((item) => {
                    return (
                      <Radio.Button
                        checked={selectedCountry == item.name}
                        key={item.id}
                        value={item}
                        style={{ margin: "3px" }}
                        disabled={diseabledOptions && item.name != 'Factura Internacional'}
                      >
                        {item.name === 'Factura Internacional' ? t('International billing') : item.name}
                      </Radio.Button>
                    );
                  })}
                </Radio.Group>
               { diseabledOptions ? (
                  <Alert style={{marginRight: "20px", marginLeft: "20px", marginTop: "10px", paddingTop: "10px", paddingBottom: "10px"}}
                    description={t("If you choose a DSP that is not LatinAd, you will only be able to make purchases in USD through an international invoice.")}
                    type="info" showIcon
                    />
                  ) : null}
              </Panel>
            </Collapse>
            <Collapse
              bordered={false}
              defaultActiveKey={["1"]}
              expandIcon={({ isActive }) => (
                <Icon type="caret-right" rotate={isActive ? 90 : 0} />
              )}
              style={{ backgroundColor: Colors.snow }}
            >
              <Panel
                header={t("Currency")}
                key="1"
                style={customPanelStyle}
                isActive={selectedCountry}
              >
              {currencies.length > 0 ? (
                <Radio.Group
                  buttonStyle="solid"
                  onChange={this.handleCurrencySelection}
                >
                  {currencies.map((item) => {
                    return (
                      <Radio.Button
                        checked={selectedCurrency == item.code}
                        key={item.code}
                        value={item.code}
                        style={{ margin: "3px" }}
                      >
                        {item.code}
                      </Radio.Button>
                    );
                  }
                  )}
                </Radio.Group>
              ) : null}
              </Panel>
            </Collapse>
            {selectedCountry == 'Factura Internacional' ? (
              <Alert description={t("You will receive an international invoice without local taxes and the payment must be in USD (American Dollars) internationally.")} type="info" showIcon />
            ) : null}
            {
              editCampaignActive && usedCurrency !== selectedCurrency ? (
                <Alert 
                  message={t("Currency change")} 
                  description={
                    <>
                      <p>
                        <Trans
                          i18nKey="Currency change explanation"
                          components={{
                            strong: <strong />,
                          }}
                        />
                      </p>
                      <div style={{ display: "flex", gap: "10px" }}>
                        <Button 
                          type={this.state.currencyOptionSelected === "keep" ? "primary" : "default"} 
                          onClick={() => this.setCurrencyOption("keep")}
                        >{t("Keep original amount")}</Button>
                        <Button 
                          type={this.state.currencyOptionSelected === "convert" ? "primary" : "default"} 
                          onClick={() => this.setCurrencyOption("convert")}
                        >{t("Convert amount")}</Button>
                      </div>
                    </>
                  } 
                  style={{ marginTop: "10px" }}
                  type="info" 
                  showIcon
                />
              ) : null
            }
          </div>
        </Row>
      </Modal>
    );
  }
}
export default withTranslation()(LanguageCurrencyModal);
// export default LanguageCurrencyModal;
